export default "__VITE_ASSET__CkL7wyo0__"